'use client';
import React from 'react';
import useMioForm from "../shared/useMioForm.jsx"
import Wrapper from "../shared/Wrapper.jsx"
import { PiMagnifyingGlass } from "react-icons/pi";

function MioNotes(p) {
    const { mioID, field, isDirty, isInvalid, isTouched } = useMioForm(p.name, p.required);
    return (
        <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty}>
            <div className="mtwi">
                <textarea
                    className={`
                        mio-form-control-input mio-form-control-textarea
                        ${p.tabular && 'tabular'}
                        ${p.search && 'mio-form-control-input-search'}
                        ${p.monospace ? 'monospace' : ''}
                        ${isInvalid ? 'mio-form-control-input-invalid ' : ''}
                        `}
                    id={mioID}
                    type="text"
                    placeholder={p.placeholder}
                    autoComplete="off"
                    {...field}
                    value={field.value ?? ''}
                    rows={p.rows ?? 1}
                >
                </textarea>
                {p.search && <div className="mio-form-control-icon mio-form-control-icon-search"><PiMagnifyingGlass /></div>}
            </div>
        </Wrapper >
    )
}
export default MioNotes